import React, { Component } from 'react';
import TableC from '../../../basicElement/TableC';
import format from '../../../shared/format';
import renderEnhancer from '../../../shared/renderEnhancer'
import { DimensionTableColumns, personDimensionTableColumns } from '../../constants/dimension';

function getCategories(props) {
    const { params, data } = props;
    if (
        (params.moduleType === 'CnyCurrentMonthIncomeNoTax' || params.moduleType === 'CurrentMonthInvoice') &&
        params.analysisDimension === 'AREA'
    ) {
        return data.dateList || [];
    }
    return data.categories || [];
}

class Table extends Component {
    shouldComponentUpdate(nextProps) {
        if (
            nextProps.data !== this.props.data ||
            nextProps.pagination !== this.props.pagination
        ) {
            return true;
        }
        return false;
    }

    getDimensionColumns = source => {
        if(source == 'person'){
            return personDimensionTableColumns
        }else if(source == 'finance') {
            return DimensionTableColumns
        }
    }

    getColumns = () => {
        const { params, source, isTwoSpecialTable = false } = this.props;
        const { analysisDimension, displayType, moduleType } = params;
        const categories = getCategories(this.props);
        const analysisDimensionKey = isTwoSpecialTable ? `${analysisDimension}_COURTYARDAREA` : analysisDimension;
        const columns = ( this.getDimensionColumns(source)[analysisDimensionKey] || [])
            .filter(i => displayType === 'All' ? i.title !== '业务线' : true)
            .map(i => ({
                title: i.title,
                dataIndex: i.key,
                key: i.key,
                fixed: 'left',
                width: i.width || 80,
                render: renderEnhancer()
            }));
        columns.push({
            title: '统计项',
            dataIndex: 'statisticName',
            key: 'statisticName',
            fixed: 'left',
            width: 120
        });
        categories.forEach(i => {
            columns.push({
                title: i,
                dataIndex: i,
                key: i,
                width: 120,
                render: text => moduleType === 'EmpOutPutRate' ? format('money', text)+'%' : format('money', text)
            });
        });
        return columns;
    }

    getDataSource = () => {
        const { data, source, params } = this.props;
        const { formData = [] } = data;
        const categories = getCategories(this.props);

        const dataSource = [];
        const len = formData.length;
        for (let i = 0; i < len; i++) {
            const current = { ...formData[i] };

            (current.data || []).forEach((value, index) => {
                current[categories[index]] = value;
            });

            if (current.plus === 0) {
                current.rowSpan = 1;
                for (let j = i + 1; j < len; j++) {
                    const next = formData[j];
                    if (next.plus === 0) {
                        break;
                    }
                    current.rowSpan++;
                }
            } else {
                current.rowSpan = source === 'person' ? current.plus === 1 ? 0 : 1 : 0;
            }
            dataSource.push(current);
        }
        // if(params.lineOfBusiness !== '-1')dataSource = dataSource.filter(i => i.lineOfBusiness == params.lineOfBusiness);
        return dataSource;
    }

    render() {
        const { pagination, onChange } = this.props;
        return (
            <TableC
                columns={this.getColumns()}
                data={this.getDataSource()}
                pagination={pagination}
                onChange={onChange}
            />
        );
    }
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/homePage/DimensionAnalysis/components/Table.js